function importAll(context) {
  return context.keys().map(context);
}

export const homeGalleryGroups = {
  Home: importAll(require.context("../watermarked/images/home", false, /\.(png|jpe?g|svg)$/)),
  Weddings: importAll(require.context("../watermarked/images/weddings", false, /\.(png|jpe?g|svg)$/)),
  Rentals: importAll(require.context("../watermarked/images/rentals", false, /\.(png|jpe?g|svg)$/)),
  "Birthday Parties": importAll(require.context("../watermarked/images/birthday", false, /\.(png|jpe?g|svg)$/)),
  "Womensday Events": importAll(require.context("../watermarked/images/womensday", false, /\.(png|jpe?g|svg)$/)),
};

export const eventGalleries = {
  weddings: importAll(require.context("../watermarked/images/weddings", false, /\.(png|jpe?g|svg)$/)),
  womensday: importAll(require.context("../watermarked/images/womensday", false, /\.(png|jpe?g|svg)$/)),
  cradle: importAll(require.context("../watermarked/images/cradleceremony", false, /\.(png|jpe?g|svg)$/)),
};
